
import { useEffect, useState } from 'react';

const GroupCard = (props) => {
    return (
        <>
          <div className="pageTbl bg-white">
                        <div>
                            {props.groupListing && (
                                <table className="table table-hover table-bordered bg-white">
                                    <tbody>
                                         <tr>
                                            <td className="fs14 fw-normal" style={{ width: "15%" }}>
                                                Group Name  :<br />
                                                <a href= "#" className="pt-2">  {props.groupListing.group_name}
                                                </a>
                                            </td>
                                        </tr>
                                         <tr>
                                            <td className="fs14 fw-normal" style={{ width: "15%" }}>
                                                Group ID  :<br />
                                                <a href= "#" className="pt-2">  {props.groupListing.master?.tap_master_id}
                                                </a>
                                            </td>
                                        </tr>
                                        
                                    </tbody>
                                </table>
                            )}
                        </div>
            </div>
        </>
    );
};

export default GroupCard;